<template>
  <s-form @submit="saveGathering">
    <fieldset class="m-form-fieldset m-form-fieldset--no-margin">
      <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">
        <!-- Les balises h2 ci-dessous ne s'agençaient pas avec le design de la maquette -->
        <!--<h2>{{ $t('label-gathering-name') }}</h2>-->
        <div class="h-grid__col h-grid__col--12">
          <name-block v-model="$v.name.$model" :canEdit="canEditName" :showError="$v.name.$dirty && !$v.name.required" />
        </div>

        <!--<h2>{{ $t('form-gathering-file-detail-section') }}</h2>-->
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <p class="m-form-group">
            <label class="a-form-label" for="description"
              >{{ $t('label-edit-gathering-description') }}<required-form-field />
              <span class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-public-information') }}</span>
            </label>
            <rich-text-editor v-model="$v.description.$model" id="description" />
            <span v-if="$v.description.$dirty">
              <span class="m-form-group__error" v-if="!$v.description.required || !$v.description.notEmptyRichText">{{ $t('error-field-required') }}</span>
            </span>
          </p>

          <p class="m-form-group">
            <label class="a-form-label">
              {{ $t('label-edit-gathering-image') }}
              <span class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-public-information') }}</span>
              <span class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-image-description') }}</span>
            </label>
            <image-picker v-model="imageFile" uniqueKey="gatheringImagePicker" v-bind:imageOriginalUrl="imageOriginalUrl" persisten-hint @removeFile="removeImage" />
          </p>

          <p class="m-form-group">
            <label class="a-form-label" for="facebookUrl"
              >{{ $t('label-edit-gathering-facebookUrl') }}<span class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-public-information') }}</span></label
            >
            <input class="a-form-control" id="facebookUrl" v-model.lazy="$v.facebookUrl.$model" autocomplete="edit-gathering facebook-url" />
            <span v-if="$v.facebookUrl.$dirty">
              <span class="m-form-group__error" v-if="!$v.facebookUrl.mustBeFacebookUrl">{{ $t('error-field-facebook-format') }}</span>
            </span>
          </p>
        </div>
      </div>
    </fieldset>

    <action-buttons
      :showSubmit="false"
      :isSubmitted="isSubmitted"
      :isAuthorized="isAuthorized"
      :errors="errors"
      @saveAndBack="saveAndBack"
      @saveAndQuit="saveAndQuit"
      @saveAndContinue="saveAndContinue"
      @previewGathering="previewGathering"
    />
  </s-form>
</template>

<script>
import SForm from '@/components/form/form'
import { required } from 'vuelidate/lib/validators'
import ActionButtons from '@/components/pages/gathering/edit-steps/action-buttons'
import RichTextEditor from '@/components/form/rich-text-editor'
import ImagePicker from '@/components/form/image-picker'
import RequiredFormField from '@/components/ui/required-form-field'
import NameBlock from '@/components/pages/gathering/edit-steps/name-block'

import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'
import ImageUploadService from '@/services/image-upload'

const mustBeFacebookUrl = value =>
  value === '' || value === null || value.indexOf('https://facebook.com/') >= 0 || value.indexOf('https://www.facebook.com/') >= 0 || value.indexOf('https://m.facebook.com/') >= 0
const notEmptyRichText = value => {
  return value !== '<p></p>'
}

export default {
  components: {
    SForm,
    ActionButtons,
    RichTextEditor,
    ImagePicker,
    RequiredFormField,
    NameBlock
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    canEditName: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      name: this.value.Name !== null ? this.value.Name : '',
      description: this.value.Description !== null ? this.value.Description : '',
      imageOriginalUrl: this.value.PhotoUri !== null ? this.value.PhotoUri : null,
      imageFile: '',
      facebookUrl: this.value.FacebookUrl !== null ? this.value.FacebookUrl : '',
      isSubmitted: this.value.IsSubmitted !== null ? this.value.IsSubmitted : false,
      isAuthorized: this.value.IsPublish !== null ? this.value.IsPublish : false
    }
  },
  validations: {
    name: {
      required
    },
    description: {
      required,
      notEmptyRichText
    },
    facebookUrl: {
      mustBeFacebookUrl
    }
  },
  computed: {
    gathering: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    errors: function() {
      const errors = []

      if (this.$v.$invalid) {
        if (!this.$v.name.required) {
          errors.push(this.$t('gathering-name-error-text'))
        }

        if (!this.$v.description.required || !this.$v.description.notEmptyRichText) {
          errors.push(this.$t('gathering-description-error-text'))
        }

        if (!this.$v.facebookUrl.mustBeFacebookUrl) {
          errors.push(this.$t('gathering-facebook-error-text'))
        }
      }

      return errors
    }
  },
  methods: {
    saveGathering: async function() {
      LoaderService.showLoader()

      const request = {
        gatheringId: this.gathering.Id
      }

      if (this.name !== this.gathering.Name) {
        request.name = { value: this.name }
      }

      if (this.description !== this.gathering.Description) {
        request.description = { value: this.description }
      }

      if (this.imageFile !== null && this.imageFile !== '') {
        const result = await ImageUploadService.sendImage(this.imageFile)
        request.photoFileId = { value: result.fileId }
      } else if (this.imageFile === '' && this.imageOriginalUrl === null) {
        request.photoFileId = { value: null }
      }

      if (this.facebookUrl !== this.gathering.FacebookUrl) {
        request.facebookUrl = { value: this.facebookUrl }
      }

      const response = await GatheringService.updateGathering(request)

      this.gathering = response
      LoaderService.hideLoader()
    },
    updateImage: function(imageFile) {
      this.imageFile = imageFile
    },
    removeImage: function() {
      this.imageOriginalUrl = null
      this.imageFile = ''
    },
    canSave: function(forceValidation = false) {
      if (this.isSubmitted || this.isAuthorized || forceValidation) {
        this.$v.$touch()
        return !this.$v.$invalid
      }
      return true
    },
    saveAndBack: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndBack')
      }
    },
    previewGathering: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('previewGathering')
      }
    },
    saveAndQuit: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndQuit')
      }
    },
    saveAndContinue: async function() {
      if (this.canSave(true)) {
        await this.saveGathering()
        this.$emit('saveAndContinue')
      }
    }
  }
}
</script>
